//#region 1️⃣ Angular Imports
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
//#endregion

//#region 2️⃣ Ionic & Angular Material
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
//#endregion

//#region 3️⃣ NgRx / Utilities
import {PushPipe} from '@ngrx/component';
//#endregion

//#region 4️⃣ Routing
import {UserAccessPageRoutingModule} from './user-access-routing.module';
//#endregion

//#region 5️⃣ Shared Modules
import {SharedModule} from '../../shared-modules/shared-module/shared-module.module';
import {SharedIconsModule} from '../../shared-modules/shared-icons/shared-icons.module';
import {SharedComponentsModule} from '../../shared/shared-components/shared-components.module';
import {UiComponentsModule} from '../../shared/shared-module-ui/ui-components.module';
//#endregion

//#region 6️⃣ Components
import {USER_ACCESS_COMPONENTS} from './components';

//#endregion

@NgModule({
  imports: [
    //#region 1️⃣ Angular & Core
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    //#endregion

    //#region 2️⃣ Ionic & Angular Material
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    //#endregion

    //#region 4️⃣ Routing
    UserAccessPageRoutingModule,
    //#endregion

    //#region 5️⃣ Shared Modules
    SharedModule,
    SharedIconsModule,
    SharedComponentsModule,
    UiComponentsModule,
    //#endregion

    //#region 3️⃣ NgRx / Utilities
    PushPipe,
    //#endregion
  ],
  declarations: [
    //#region 6️⃣ Components
    USER_ACCESS_COMPONENTS,
    //#endregion
  ],
})
export class UserAccessPageModule {
}
